import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/listings/admin/adminListingQueryKeys.ts
var t = e("admin-listings", {
	list: (e) => ["list", e ?? {}],
	detail: (e) => ["detail", e],
	images: (e) => ["images", e],
	moderation: (e, t) => [
		"moderation",
		e ?? "all",
		t ?? []
	],
	listingModeration: (e) => e === void 0 ? ["listing-moderation"] : ["listing-moderation", e]
});
//#endregion
export { t as adminListingQueryKeys };
